import React from 'react';
import { connect } from 'react-redux';
import { RealtimeAudioAnalyzer } from '../../Audio/RealtimeAudioAnalyzer';
import { createActions } from '../../store';
import { createObjectCopy } from '../../../../../utilities/objectUtilities';
import CreatePageConstants, { DEFAULT_AUDIO_TRACK } from '../../CreatePageConstants';
import { appOperations } from '../../../../../App/store';
import ColoredSnackbarConstants from '../../../../misc/ColoredSnackbar/ColoredSnackbarConstants';
import { GlobalAudioEventListeners } from '../../Audio/helpers/GlobalAudioEventListeners';
import { getAudioVolume } from '../../../../../utilities/storageUtilities';

const AudioElementId = 'audio-analyzer-element';

class AudioElement extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { audioUrl } = this.props;

        return (
            <audio 
                id={AudioElementId}
                preload='auto'
                loop
                playsInline
                src={audioUrl}
                crossOrigin='anonymous'
                volume={1}
            />
        );
    }

    componentDidMount = () => {
        const { openSnack } = this.props;
        const audioElement = document.getElementById(AudioElementId);

        GlobalAudioEventListeners.attachElement(audioElement);
        RealtimeAudioAnalyzer.attachElement(audioElement);
        RealtimeAudioAnalyzer.setMaxMagnitudes(undefined, undefined);

        audioElement.addEventListener('error', (event) => {
            openSnack(`Can't load the audio files for preview.`, ColoredSnackbarConstants.SNACKBAR_ERROR);
        }, true);
    }

    componentDidUpdate = (prevProps) => {
        const { bassMaxMagnitude, wideMaxMagnitude, audioMuted, audioUrl } = this.props;

        if (bassMaxMagnitude && wideMaxMagnitude) {
            RealtimeAudioAnalyzer.setMaxMagnitudes(bassMaxMagnitude, wideMaxMagnitude);
        }

        if (prevProps.audioUrl != audioUrl) {
            const audioVolume = (!audioUrl || audioUrl == DEFAULT_AUDIO_TRACK.SOUND_URL || audioMuted) ? 0 :  getAudioVolume();
            RealtimeAudioAnalyzer.setVolume(audioVolume);
        }
    }

    componentWillUnmount = () => {
        const { clearAudioSettings } = this.props;
        const audioElement = document.getElementById(AudioElementId);

        GlobalAudioEventListeners.detachElement(audioElement);
        RealtimeAudioAnalyzer.detachElement();
        clearAudioSettings();
    }
}

const mapStateToProps = (state) => {
    const { 
        url: audioUrl,
        bassMaxMagnitude,
        wideMaxMagnitude
    } = state.create.audioSettings;

    const { audioMuted } = state.create;
    
    return { 
        audioUrl,
        audioMuted,
        bassMaxMagnitude,
        wideMaxMagnitude
    };
}

const mapDispatchToProps = (dispatch) => {
    const clearAudioSettings = () => dispatch(createActions.updateAudioSettings(createObjectCopy(CreatePageConstants.DEFAULT_AUDIO_SETTINGS)));
    const openSnack = (text, variant) => dispatch(appOperations.openSnack(text, variant));

    return {
        clearAudioSettings,
        openSnack
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AudioElement);